import {Tag} from './Tag';

interface TagListProps {
  tags: string[];
}

export const TagContainer: React.FC<TagListProps> = ({tags}) => {
  return (
    <div
      style={{
        marginTop: '20px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
      }}>
      {tags.map((tag, index) => (
        <Tag key={`${tag}-${index}`} label={tag} />
      ))}
    </div>
  );
};
